import { Component, ViewEncapsulation, Input, OnInit } from '@angular/core';

@Component({
    selector: 'tidy-modal',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./modal.component.scss'],
    template: `
    <ng-container>
      <tidy-card>
        <tidy-row>
          <tidy-text [header]="title"> </tidy-text>
        </tidy-row>
        <ng-content>
        </ng-content>
      </tidy-card>
    </ng-container>

  `,
    standalone: false
})

export  class ModalComponent implements OnInit {

  @Input() title: string;

  ngOnInit() {
    // No initialization needed
  }

}
